import { LoyaltyOffer, LoyaltyReward, isReward } from 'state/loyalty/types';
import { maybeLocaleImage, maybeLocaleImages } from 'utils/graphql';
import { blockContentToPlainText } from 'utils/sanity';

export const parseIncentiveData = (incentive: LoyaltyReward | LoyaltyOffer) => {
  const incentiveData = isReward(incentive)
    ? {
        description: incentive?.description?.locale,
        image: maybeLocaleImage(incentive?.image),
        imageDescription: incentive?.imageDescription?.locale || '',
        name: incentive?.name?.locale || '',
        moreInfo: incentive?.moreInfo?.enRaw,
        isOffer: false,
        metadata: null,
      }
    : {
        description: incentive?.description?.localeRaw,
        image: maybeLocaleImages(incentive?.localizedImage),
        imageDescription: '',
        name: blockContentToPlainText(incentive?.name?.localeRaw),
        moreInfo: incentive?.moreInfo?.localeRaw,
        isOffer: true,
        metadata: incentive?.metadata,
      };
  return {
    id: incentive?._id,
    backgroundImage: incentive?.backgroundImage,
    loyaltyEngineId: incentive?.loyaltyEngineId ?? '',

    ...incentiveData,
  };
};
